import { render, staticRenderFns } from "./Competition2022Page.vue?vue&type=template&id=5576a234&scoped=true&"
import script from "./Competition2022Page.vue?vue&type=script&lang=js&"
export * from "./Competition2022Page.vue?vue&type=script&lang=js&"
import style0 from "./Competition2022Page.vue?vue&type=style&index=0&id=5576a234&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5576a234",
  null
  
)

export default component.exports